import React from 'react';
export function Testimonials() {
  return <section className="mb-24" data-id="element-473">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-8 leading-tight font-['Playfair_Display']" data-id="element-474">
        Real Transformations, Real People
      </h2>
      {/* Before/After Transformations */}
      <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-475">
        <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 border border-[#7F8C8D]/10" data-id="element-476">
          <div className="relative" data-id="element-477">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xcEMFfHSfnmTXicFskYaeW/u8357357769_Before_and_after_comparison_South_Indian_man_age__70e2b55f-2ede-441f-a7b6-ad94c66411b9_3.png" alt="Before and after transformation showing reduced fine lines around eyes" className="w-full h-auto" data-id="element-478" />
            <div className="absolute bottom-0 left-0 bg-gradient-to-r from-[#FFB88C] to-[#FFE5D9] text-[#1B2951] px-3 py-1 text-sm font-medium" data-id="element-479">
              Day 30 Results
            </div>
          </div>
          <div className="p-6" data-id="element-480">
            <div className="flex items-center mb-4" data-id="element-481">
              <div className="w-12 h-12 rounded-full mr-4 bg-[#FFE5D9] flex items-center justify-center text-[#1B2951] font-bold text-xl" data-id="element-482">
                V
              </div>
              <div data-id="element-483">
                <h3 className="font-semibold text-[#1B2951] font-['Poppins']" data-id="element-484">
                  Vikram, 58
                </h3>
                <p className="text-[#7F8C8D] text-sm font-['Inter']" data-id="element-485">Chennai</p>
              </div>
            </div>
            <p className="text-[#2C3E50] italic mb-4 font-['Inter']" data-id="element-486">
              "The fine lines around my eyes started disappearing after just 2
              weeks"
            </p>
            <div className="text-[#FFB88C]" data-id="element-487">⭐⭐⭐⭐⭐</div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 border border-[#7F8C8D]/10" data-id="element-488">
          <div className="relative" data-id="element-489">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1MRTRSCc6wAk6sPrs4j5Ct/u8357357769_Medical_before_and_after_documentation_SAME_India_6aada6d5-12cf-45dd-9d7f-13eff375bd52_0.png" alt="Before and after transformation showing smoother skin around eyes" className="w-full h-auto" data-id="element-490" />
            <div className="absolute bottom-0 left-0 bg-gradient-to-r from-[#FFB88C] to-[#FFE5D9] text-[#1B2951] px-3 py-1 text-sm font-medium" data-id="element-491">
              Day 50 Results
            </div>
          </div>
          <div className="p-6" data-id="element-492">
            <div className="flex items-center mb-4" data-id="element-493">
              <div className="w-12 h-12 rounded-full mr-4 bg-[#FFE5D9] flex items-center justify-center text-[#1B2951] font-bold text-xl" data-id="element-494">
                P
              </div>
              <div data-id="element-495">
                <h3 className="font-semibold text-[#1B2951] font-['Poppins']" data-id="element-496">
                  Priya, 42
                </h3>
                <p className="text-[#7F8C8D] text-sm font-['Inter']" data-id="element-497">
                  Hyderabad
                </p>
              </div>
            </div>
            <p className="text-[#2C3E50] italic mb-4 font-['Inter']" data-id="element-498">
              "My under-eye wrinkles visibly reduced in just 15 days!"
            </p>
            <div className="text-[#FFB88C]" data-id="element-499">⭐⭐⭐⭐⭐</div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 border border-[#7F8C8D]/10" data-id="element-500">
          <div className="relative" data-id="element-501">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2kPauGkKepFMgb3R3ZZyji/u8357357769_Side_by_side_transformation_Bengali_woman_age_40__f28976e5-f279-4297-a8df-6069a9e63501_2.png" alt="Before and after transformation showing improved skin texture and reduced neck wrinkles" className="w-full h-auto" data-id="element-502" />
            <div className="absolute bottom-0 left-0 bg-gradient-to-r from-[#FFB88C] to-[#FFE5D9] text-[#1B2951] px-3 py-1 text-sm font-medium" data-id="element-503">
              Day 45 Results
            </div>
          </div>
          <div className="p-6" data-id="element-504">
            <div className="flex items-center mb-4" data-id="element-505">
              <div className="w-12 h-12 rounded-full mr-4 bg-[#FFE5D9] flex items-center justify-center text-[#1B2951] font-bold text-xl" data-id="element-506">
                S
              </div>
              <div data-id="element-507">
                <h3 className="font-semibold text-[#1B2951] font-['Poppins']" data-id="element-508">
                  Suchitra, 47
                </h3>
                <p className="text-[#7F8C8D] text-sm font-['Inter']" data-id="element-509">Kolkata</p>
              </div>
            </div>
            <p className="text-[#2C3E50] italic mb-4 font-['Inter']" data-id="element-510">
              "The neck wrinkles that bothered me for years - gone in 45 days!"
            </p>
            <div className="text-[#FFB88C]" data-id="element-511">⭐⭐⭐⭐⭐</div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 border border-[#7F8C8D]/10" data-id="element-512">
          <div className="relative" data-id="element-513">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6a2ZWreM9aH9q7v4FVrGeb/u8357357769_Split_screen_before_and_after_Indian_woman_age_45_f2277b02-1115-4bff-9de0-a91ab3509fb5_3.png" alt="Before and after transformation showing reduced crow's feet and smoother skin" className="w-full h-auto" data-id="element-514" />
            <div className="absolute bottom-0 left-0 bg-gradient-to-r from-[#FFB88C] to-[#FFE5D9] text-[#1B2951] px-3 py-1 text-sm font-medium" data-id="element-515">
              Day 21 Results
            </div>
          </div>
          <div className="p-6" data-id="element-516">
            <div className="flex items-center mb-4" data-id="element-517">
              <div className="w-12 h-12 rounded-full mr-4 bg-[#FFE5D9] flex items-center justify-center text-[#1B2951] font-bold text-xl" data-id="element-518">
                L
              </div>
              <div data-id="element-519">
                <h3 className="font-semibold text-[#1B2951] font-['Poppins']" data-id="element-520">
                  Lakshmi, 45
                </h3>
                <p className="text-[#7F8C8D] text-sm font-['Inter']" data-id="element-521">Pune</p>
              </div>
            </div>
            <p className="text-[#2C3E50] italic mb-4 font-['Inter']" data-id="element-522">
              "My friends asked if I got a treatment done. It was just 3 weeks
              of this!"
            </p>
            <div className="text-[#FFB88C]" data-id="element-523">⭐⭐⭐⭐⭐</div>
          </div>
        </div>
      </div>
      {/* Original Testimonials */}
      <div className="grid md:grid-cols-3 gap-6" data-id="element-524">
        <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 hover:scale-[1.02] border border-[#7F8C8D]/10" data-id="element-525">
          <div className="p-6" data-id="element-526">
            <div className="flex items-center mb-4" data-id="element-527">
              <div className="w-12 h-12 rounded-full mr-4 bg-[#FFE5D9] flex items-center justify-center text-[#1B2951] font-bold text-xl" data-id="element-528">
                M
              </div>
              <div data-id="element-529">
                <h3 className="font-semibold text-[#1B2951] font-['Poppins']" data-id="element-530">
                  Meera, 45
                </h3>
                <p className="text-[#7F8C8D] text-sm font-['Inter']" data-id="element-531">Delhi</p>
              </div>
            </div>
            <p className="text-[#2C3E50] italic mb-4 font-['Inter']" data-id="element-532">
              "First time my husband noticed without me asking"
            </p>
            <div className="text-[#FFB88C]" data-id="element-533">⭐⭐⭐⭐⭐</div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 hover:scale-[1.02] border border-[#7F8C8D]/10" data-id="element-534">
          <div className="p-6" data-id="element-535">
            <div className="flex items-center mb-4" data-id="element-536">
              <div className="w-12 h-12 rounded-full mr-4 bg-[#FFE5D9] flex items-center justify-center text-[#1B2951] font-bold text-xl" data-id="element-537">
                A
              </div>
              <div data-id="element-538">
                <h3 className="font-semibold text-[#1B2951] font-['Poppins']" data-id="element-539">
                  Anjali, 52
                </h3>
                <p className="text-[#7F8C8D] text-sm font-['Inter']" data-id="element-540">
                  Mumbai (Menopausal)
                </p>
              </div>
            </div>
            <p className="text-[#2C3E50] italic mb-4 font-['Inter']" data-id="element-541">
              "The tightness was gone in 2 weeks"
            </p>
            <div className="text-[#FFB88C]" data-id="element-542">⭐⭐⭐⭐⭐</div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 hover:scale-[1.02] border border-[#7F8C8D]/10" data-id="element-543">
          <div className="p-6" data-id="element-544">
            <div className="flex items-center mb-4" data-id="element-545">
              <div className="w-12 h-12 rounded-full mr-4 bg-[#FFE5D9] flex items-center justify-center text-[#1B2951] font-bold text-xl" data-id="element-546">
                R
              </div>
              <div data-id="element-547">
                <h3 className="font-semibold text-[#1B2951] font-['Poppins']" data-id="element-548">
                  Raj, 38
                </h3>
                <p className="text-[#7F8C8D] text-sm font-['Inter']" data-id="element-549">
                  Bangalore
                </p>
              </div>
            </div>
            <p className="text-[#2C3E50] italic mb-4 font-['Inter']" data-id="element-550">
              "Unexpected bonus - my beard became fuller!"
            </p>
            <div className="text-[#FFB88C]" data-id="element-551">⭐⭐⭐⭐⭐</div>
          </div>
        </div>
      </div>
    </section>;
}